<template>
  <div>
    <div class="page-header">
      <div class="page-leftheader">
        <div class="headline">
          <h4 class="page-title text-primary">Alle Routen</h4>
        </div>
      </div>
    </div>
    <div>
      <div>
        <input
          v-model="search"
          type="search"
          class="form-control form-control-sm"
          placeholder="Suche..."
          aria-controls="example1"
        />
        <br />
      </div>
      <div>
        <div>
          <div class="card">
            <div class="card-body text-center text-danger" v-if="routesError">
              {{ routesError }}
            </div>
            <div class="card-body text-center text-muted" v-else-if="routesGeladen && routes.length === 0">
              Keine Routen gefunden.
            </div>
            <div class="table-responsive" v-else>
              <table class="table card-table table-vcenter text-nowrap">
                <thead>
                  <tr>
                    <th>Kartenausschnitt</th>
                    <th>Bilder</th>
                    <th>Titel</th>
                    <th>Streckenlänge</th>
                    <th>Privat</th>
                    <th>Erstellt am</th>
                    <th>Aktion</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="route in routes" :key="route._id">
                    <td class="align-middle">
                      <svg
                        v-if="routeLinePoints(route)"
                        width="120"
                        height="80"
                        viewBox="0 0 120 80"
                        class="rounded"
                        style="background:#f4f4f4"
                      >
                        <polyline
                          :points="routeLinePoints(route)"
                          fill="none"
                          stroke="#1E88E5"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      <svg
                        v-else-if="startEndPoints(route)"
                        width="120"
                        height="80"
                        viewBox="0 0 120 80"
                        class="rounded"
                        style="background:#f4f4f4"
                      >
                        <circle :cx="startEndPoints(route).start[0]" :cy="startEndPoints(route).start[1]" r="4" fill="#43A047" />
                        <circle :cx="startEndPoints(route).end[0]" :cy="startEndPoints(route).end[1]" r="4" fill="#E53935" />
                      </svg>
                      <span v-else class="text-muted">kein Streckenverlauf</span>
                    </td>
                    <td class="align-middle">
                      <div class="route-preview" @click="openGallery(route)" v-if="firstImage(route)">
                        <img
                          :src="`${$img(firstImage(route), $awsSmallImages)}`"
                          alt=""
                          class="route-preview-image"
                          @error="handleImageError"
                        />
                        <span class="post-image-count" v-if="imageCount(route) > 1">
                          {{ imageCount(route) }}
                        </span>
                      </div>
                      <span v-else class="text-muted">kein Bild</span>
                    </td>
                    <td class="align-middle">{{ route.title || 'ohne Titel' }}</td>
                    <td class="align-middle">{{ formatDistance(route.totalTripDistance) }}</td>
                    <td class="align-middle">{{ route.isPrivate ? 'Ja' : 'Nein' }}</td>
                    <td class="align-middle">{{ $formatDate(route.createdAt) }}</td>
                    <td>
                      <a
                        title="Route bearbeiten"
                        class="btn btn-primary btn-small mr-1"
                        @click="openEditRoute(route)"
                        ><i class="fas fa-edit"></i
                      ></a>
                      <a
                        title="Route löschen"
                        class="btn btn-small btn-danger"
                        @click="openDeleteRoute(route)"
                        ><i class="fas fa-trash-alt"></i
                      ></a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div style="position:absolute; bottom: 500px;left:50%;height:40px;width:40px " v-intersect.quiet="infiniteScrolling"></div>
        </div>

        <v-dialog v-model="editDialog" width="500">
          <v-card>
            <v-card-title class="card">
              <h4 class="page-title text-primary">Route bearbeiten</h4>
            </v-card-title>
            <v-card-text>
              <div class="form-group">
                <label class="form-label">Titel</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Titel"
                  v-model="editRoute.title"
                  v-bind:class="{
                    'is-invalid':
                      emptyValidation &&
                      (editRoute.title == null || editRoute.title == ''),
                  }"
                />
              </div>
              <div class="form-group">
                <label class="form-label">Beschreibung</label>
                <textarea
                  rows="4"
                  class="form-control"
                  placeholder="Beschreibung"
                  v-model="editRoute.description"
                ></textarea>
              </div>
              <div class="form-group form-check">
                <input
                  type="checkbox"
                  class="form-check-input"
                  id="editRoutePrivate"
                  v-model="editRoute.isPrivate"
                />
                <label class="form-check-label" for="editRoutePrivate">Privat (nur für den Ersteller sichtbar)</label>
              </div>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <a
                class="btn btn-primary btn-pill mr-1"
                @click="editDialog = false"
                >Abbrechen</a
              >
              <a class="btn btn-primary btn-pill" @click="saveRoute()"
                >Speichern</a
              >
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="deleteDialog" width="500">
          <v-card>
            <v-card-title class="card">
              <h4 class="page-title text-primary">Route löschen</h4>
            </v-card-title>
            <v-card-text>
              Sind Sie sicher, dass Sie die Route „{{ editRoute.title || 'ohne Titel' }}" endgültig löschen wollen?
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <a
                class="btn btn-primary btn-pill mr-1"
                @click="deleteDialog = false"
                >Abbrechen</a
              >
              <a class="btn btn-danger btn-pill" @click="deleteRoute(editRoute)"
                >Löschen</a
              >
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="emptyDialog" width="300">
          <v-card>
            <br />
            <v-card-text>
              Der Titel darf nicht leer sein.
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <a
                class="btn btn-primary btn-pill mr-1"
                @click="emptyDialog = false"
                >Okay</a
              >
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- Großansicht für die Streckenbilder: gleiches Muster wie der
             Bilder-Reiter in Posts.vue (openGallery/galleryImages/gallery-*). -->
        <v-dialog v-model="galleryDialog" max-width="1000" content-class="gallery-dialog">
          <div class="gallery-view" v-if="galleryRoute">
            <div class="gallery-head">
              <div>{{ galleryRoute.title || 'ohne Titel' }}</div>
              <a class="gallery-close" @click="galleryDialog = false" title="Schließen">
                <i class="fe fe-x"></i>
              </a>
            </div>

            <div class="gallery-stage">
              <a
                class="gallery-arrow gallery-arrow-left"
                v-if="galleryImages.length > 1"
                @click="showPreviousImage()"
                title="Vorheriges Bild"
              >
                <i class="fe fe-chevron-left"></i>
              </a>

              <img
                v-if="galleryImages.length > 0"
                :src="`${$img(galleryImages[galleryIndex].url, $awsLargeImages)}`"
                alt=""
                class="gallery-image"
                @error="handleImageError"
              />

              <a
                class="gallery-arrow gallery-arrow-right"
                v-if="galleryImages.length > 1"
                @click="showNextImage()"
                title="Nächstes Bild"
              >
                <i class="fe fe-chevron-right"></i>
              </a>
            </div>

            <div class="gallery-foot" v-if="galleryImages.length > 1">
              <span>Bild {{ galleryIndex + 1 }} von {{ galleryImages.length }}</span>
            </div>
          </div>
        </v-dialog>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Routes",

  data() {
    return {
      page: 0,
      ElementPerPage: 25,
      search: "",

      routes: [],
      // Steht auf false, solange die erste Antwort des Servers aussteht —
      // gleiches Muster wie Trips.vue (tripsGeladen), verhindert eine
      // Leermeldung waehrend des Ladens.
      routesGeladen: false,
      routesError: '',
      lastRoutes: null,

      editRoute: {},
      editDialog: false,
      deleteDialog: false,
      emptyDialog: false,
      emptyValidation: false,

      // Großansicht der Streckenbilder — gleiches Muster wie Posts.vue.
      galleryDialog: false,
      galleryRoute: null,
      galleryIndex: 0,
    };
  },

  watch: {
    search: function () {
      if (this.search == "") {
        this.fetchRoute();
      } else {
        this.page = 0;
        this.searchRoute();
      }
    },
  },

  mounted() {
    this.fetchRoute();
    window.addEventListener('keydown', this.handleGalleryKeys);
  },

  beforeDestroy() {
    window.removeEventListener('keydown', this.handleGalleryKeys);
  },

  computed: {
    /** Bilder der gerade geöffneten Route. */
    galleryImages() {
      if (!this.galleryRoute || !this.galleryRoute.galleryImages) return [];
      return this.galleryRoute.galleryImages;
    },
  },

  methods: {
    /**
     * Erstes Bild einer Route — mit Absicherung, weil eine Route auch ohne
     * Bild vorliegen kann (gleiches Muster wie firstImage() in Posts.vue).
     */
    firstImage(route) {
      if (!route || !route.galleryImages || route.galleryImages.length === 0) return null;
      return route.galleryImages[0].url;
    },
    imageCount(route) {
      if (!route || !route.galleryImages) return 0;
      return route.galleryImages.length;
    },
    openGallery(route) {
      this.galleryRoute = route;
      this.galleryIndex = 0;
      this.galleryDialog = true;
    },
    showNextImage() {
      if (this.galleryImages.length === 0) return;
      this.galleryIndex = (this.galleryIndex + 1) % this.galleryImages.length;
    },
    showPreviousImage() {
      if (this.galleryImages.length === 0) return;
      this.galleryIndex =
        (this.galleryIndex - 1 + this.galleryImages.length) % this.galleryImages.length;
    },
    /** Blättern per Pfeiltasten, solange die Großansicht offen ist. */
    handleGalleryKeys(event) {
      if (!this.galleryDialog) return;
      if (event.key === 'ArrowRight') this.showNextImage();
      if (event.key === 'ArrowLeft') this.showPreviousImage();
    },
    // Fängt eine kaputte Bildadresse ab (Datei im Bildspeicher gelöscht,
    // Upload nur halb durchgelaufen) — gleiches Muster wie in Trips.vue/Posts.vue.
    handleImageError(event) {
      const fallbackImage = '/images/brand/favicon.png';
      if (event.target.getAttribute('src') === fallbackImage) return;
      event.target.src = fallbackImage;
    },
    infiniteScrolling(entries, observer, isIntersecting) {
      if (isIntersecting) {
        setTimeout(() => {
          var _this = this;
          if (this.lastRoutes > 0 || this.lastRoutes == null) {
            if (this.search == "" || this.search == null) {
              this.page++;
              this.$axios
                .post('/route/all/' + this.page * this.ElementPerPage + '/' + this.ElementPerPage, {})
                .then(function (response) {
                  const data = (response.data && response.data.data) || [];
                  _this.lastRoutes = data.length;
                  if (data.length >= 1) {
                    data.forEach(item => _this.routes.push(item));
                  }
                })
                .catch(this.onError);
            } else {
              this.page++;
              // Suchbegriff kodieren: unkodiert bricht ein "/" oder "?" im
              // Suchtext die Route auf (gleiches Muster wie Trips.vue).
              this.$axios
                .get('/route/search/' + encodeURIComponent(this.search) + '/' + this.page * this.ElementPerPage + '/' + this.ElementPerPage)
                .then(function (response) {
                  const data = (response.data && response.data.data) || [];
                  _this.lastRoutes = data.length;
                  if (data.length >= 1) {
                    data.forEach(item => _this.routes.push(item));
                  }
                })
                .catch(this.onError);
            }
          }
        }, 500);
      }
    },
    fetchRoute() {
      var _this = this;
      this.page = 0;
      this.routesError = '';
      this.$axios
        .post('/route/all/0/' + this.ElementPerPage, {})
        .then(function (response) {
          const data = (response.data && response.data.data) || [];
          _this.routes = data;
          _this.lastRoutes = data.length;
          _this.routesGeladen = true;
        })
        .catch(function (error) {
          _this.routesError = _this.failureMessage(error) || 'Die Anfrage ist fehlgeschlagen.';
          _this.routesGeladen = true;
          _this.onError(error);
        });
    },
    searchRoute() {
      var _this = this;
      this.routesError = '';
      this.$axios
        .get('/route/search/' + encodeURIComponent(this.search) + '/' + this.page + '/' + this.ElementPerPage)
        .then(function (response) {
          if (response.data == null || response.data.success === false) {
            _this.routesError = _this.failureMessage(response.data) || 'Der Server hat die Anfrage abgelehnt.';
            _this.routesGeladen = true;
            _this.onError(response.data);
            return;
          }
          _this.routes = response.data.data || [];
          _this.lastRoutes = _this.routes.length;
          _this.routesGeladen = true;
        })
        .catch(function (error) {
          _this.routesError = _this.failureMessage(error) || 'Die Anfrage ist fehlgeschlagen.';
          _this.routesGeladen = true;
          _this.onError(error);
        });
    },
    // Gleiches Muster wie Trips.vue/Users.vue/Reported.vue.
    onError(err) {
      if (err != null && err.response != null && err.response.data != null) {
        console.error(err.response.data);
      } else {
        console.error(err);
      }
      const status = err != null && err.response != null ? err.response.status : null;
      if (status === 401 || status === 403) return;
      this.$noty.error(this.failureMessage(err) || 'Die Anfrage ist fehlgeschlagen.');
    },
    failureMessage(err) {
      if (err == null) return null;
      if (err.response != null && err.response.data != null && err.response.data.message) {
        return err.response.data.message;
      }
      if (err.response == null && err.success === false && err.message) {
        return err.message;
      }
      return null;
    },
    formatDistance(meters) {
      if (!meters) return '—';
      return (meters / 1000).toFixed(1) + ' km';
    },
    // Selbst gezeichnete Streckenvorschau statt einer echten Kartenkachel —
    // gleiches Vorgehen wie RouteThumbnailPainter in der App
    // (route_thumbnail_painter.dart): rein aus dem bereits gespeicherten
    // routeCoordinates-String, ohne API-Aufruf. Eine volle interaktive
    // GmapMap-Instanz je Tabellenzeile (wie GoogleMap.vue sie für genau
    // einen Bearbeiten-Dialog nutzt) wäre bei potenziell hunderten Routen in
    // einer scrollenden Liste viel zu schwer, und Googles Static-Maps-API
    // ist für diesen API-Schlüssel gar nicht freigeschaltet (HTTP 403,
    // "This API is not activated on your API project" — separat von der
    // Maps-JavaScript-API, die für die Adressauswahl bereits läuft).
    //
    // Google-codierte Polylines (Präzision 5) dekodieren — Standardalgorithmus,
    // siehe https://developers.google.com/maps/documentation/utilities/polylinealgorithm.
    decodePolyline(encoded) {
      const points = [];
      let index = 0, lat = 0, lng = 0;
      while (index < encoded.length) {
        let result = 1, shift = 0, b;
        do {
          b = encoded.charCodeAt(index++) - 63 - 1;
          result += b << shift;
          shift += 5;
        } while (b >= 0x1f);
        lat += (result & 1) ? ~(result >> 1) : (result >> 1);

        result = 1;
        shift = 0;
        do {
          b = encoded.charCodeAt(index++) - 63 - 1;
          result += b << shift;
          shift += 5;
        } while (b >= 0x1f);
        lng += (result & 1) ? ~(result >> 1) : (result >> 1);

        points.push([lat * 1e-5, lng * 1e-5]);
      }
      return points;
    },
    isRealCoordinate(coordinates) {
      // [0, 0] ist der Schema-Standardwert bei fehlender Adresse
      // (models/Route.js) — kein echter Ort im Golf von Guinea.
      return Array.isArray(coordinates) &&
        coordinates.length === 2 &&
        (coordinates[0] !== 0 || coordinates[1] !== 0);
    },
    // [x, y]-Paare innerhalb eines 120×80-Rahmens, mittig um den Schwerpunkt
    // der Strecke — mit cos(Breite)-Korrektur, sonst erscheint die Strecke
    // bei mitteleuropäischen Breiten gestaucht (gleicher Fehler, den die
    // App-Miniatur am 14.08. schon einmal hatte, hier gleich richtig).
    projectPoints(points, width, height, padding) {
      const lats = points.map(p => p[0]);
      const lngs = points.map(p => p[1]);
      const centerLat = (Math.min(...lats) + Math.max(...lats)) / 2;
      const centerLng = (Math.min(...lngs) + Math.max(...lngs)) / 2;
      const metersPerLat = 111320;
      const metersPerLng = metersPerLat * Math.cos(centerLat * Math.PI / 180);

      const meterPoints = points.map(p => [
        (p[1] - centerLng) * metersPerLng,
        (p[0] - centerLat) * metersPerLat,
      ]);
      const xs = meterPoints.map(p => p[0]);
      const ys = meterPoints.map(p => p[1]);
      const spanMeters = Math.max(
        Math.max(...xs) - Math.min(...xs),
        Math.max(...ys) - Math.min(...ys),
        1,
      );
      const drawable = Math.min(width, height) - padding * 2;
      const scale = drawable / spanMeters;

      return meterPoints.map(([dx, dy]) => [
        width / 2 + dx * scale,
        // Breite wächst nach oben, SVG-y nach unten.
        height / 2 - dy * scale,
      ]);
    },
    routeLinePoints(route) {
      if (!route.routeCoordinates) return null;
      let decoded;
      try {
        decoded = this.decodePolyline(route.routeCoordinates);
      } catch (e) {
        // Kaputt codierter String — Miniatur einfach weglassen, kein
        // Abbruchgrund für die ganze Zeile.
        return null;
      }
      if (decoded.length < 2) return null;
      const projected = this.projectPoints(decoded, 120, 80, 6);
      return projected.map(([x, y]) => `${x.toFixed(1)},${y.toFixed(1)}`).join(' ');
    },
    // Aufgezeichnete Strecken ohne gespeicherte Kartenlinie (ältere
    // Testdaten) zeigen ersatzweise Start-/Zielpunkt.
    startEndPoints(route) {
      const start = route.startPointAddress && route.startPointAddress.location &&
        this.isRealCoordinate(route.startPointAddress.location.coordinates)
        ? route.startPointAddress.location.coordinates
        : null;
      const end = route.endPointAddress && route.endPointAddress.location &&
        this.isRealCoordinate(route.endPointAddress.location.coordinates)
        ? route.endPointAddress.location.coordinates
        : null;
      if (!start || !end) return null;
      const projected = this.projectPoints(
        [[start[1], start[0]], [end[1], end[0]]], 120, 80, 10,
      );
      return { start: projected[0], end: projected[1] };
    },
    openEditRoute(route) {
      // Echte Kopie statt Referenz auf die Tabellenzeile — sonst würde ein
      // ungespeicherter Tippfehler im Dialog sofort auch in der Tabelle
      // erscheinen (gleiches Muster wie openEditTrip() in Trips.vue).
      this.editRoute = JSON.parse(JSON.stringify(route));
      this.editDialog = true;
    },
    openDeleteRoute(route) {
      this.editRoute = route;
      this.deleteDialog = true;
    },
    saveRoute() {
      let _this = this;
      this.emptyValidation = true;
      if (!this.editRoute.title || !this.editRoute.title.trim()) {
        this.emptyDialog = true;
        return;
      }
      // /route/update läuft (wie /trip/update) über multer (multipleUpload-
      // Middleware) — ein einfaches URLSearchParams-Objekt käme dort nicht an.
      // $formatUrlEncoded baut dasselbe FormData wie Trips.vue/saveTripToServer.
      //
      // WICHTIG: updateRoute im Backend setzt stopOvers UNBEDINGT aus dem
      // Anfragerumpf (route.stopOvers = safeJsonParse(body.stopOvers) || []),
      // anders als startPointAddress/endPointAddress/galleryImages, die nur bei
      // tatsächlich mitgeschicktem Wert übernommen werden. Ohne dieses Feld
      // würde jedes Speichern hier den einzelnen Streckenmittelpunkt löschen,
      // den die $geoNear-Umkreissuche für diese Route braucht (models/Route.js,
      // GEO_INDEX_KEY) — die Route wäre danach über die Umkreissuche in der App
      // nicht mehr auffindbar. Deshalb unverändert zurückschicken.
      const body = this.$formatUrlEncoded({
        tripId: this.editRoute._id,
        title: this.editRoute.title,
        description: this.editRoute.description || '',
        isPrivate: this.editRoute.isPrivate ? 'true' : 'false',
        stopOvers: this.editRoute.stopOvers || [],
      });

      this.$axios
        .put('/route/update', body)
        .then(function (response) {
          if (response.data && response.data.success === false) {
            _this.onError(response.data);
            return;
          }
          _this.editDialog = false;
          _this.fetchRoute();
        })
        .catch(function (error) {
          _this.onError(error);
        });
    },
    deleteRoute(route) {
      let _this = this;
      this.$axios
        .delete('/route/delete/' + route._id)
        .then(function (response) {
          if (response.data && response.data.success === false) {
            _this.onError(response.data);
            return;
          }
          _this.deleteDialog = false;
          _this.fetchRoute();
        })
        .catch(function (error) {
          _this.onError(error);
        });
    },
  },
};
</script>

<style scoped>
.v-dialog > .v-card > .v-card__actions {
  padding: 8px 16px;
}

/* --- Bild-Miniatur in der Tabelle ----------------------------------------- */

.route-preview {
  position: relative;
  width: 48px;
  height: 48px;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  background: rgba(148, 163, 184, 0.15);
}

.route-preview-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.post-image-count {
  position: absolute;
  top: 2px;
  right: 2px;
  min-width: 16px;
  padding: 0 4px;
  border-radius: 8px;
  background: rgba(0, 0, 0, 0.65);
  color: #fff;
  font-size: 10px;
  line-height: 16px;
  text-align: center;
}

/* --- Großansicht ----------------------------------------------------------- */

.gallery-view {
  background: #1a1d29;
  border-radius: 12px;
  overflow: hidden;
}

.gallery-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  color: #fff;
}

.gallery-close {
  font-size: 20px;
  line-height: 1;
  cursor: pointer;
  padding: 4px 8px;
  color: #fff;
}

.gallery-stage {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #000;
  min-height: 320px;
  max-height: 68vh;
}

.gallery-image {
  max-width: 100%;
  max-height: 68vh;
  object-fit: contain;
}

.gallery-arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.5);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  cursor: pointer;
  z-index: 2;
}

.gallery-arrow:hover {
  background: rgba(0, 0, 0, 0.75);
}

.gallery-arrow-left {
  left: 12px;
}

.gallery-arrow-right {
  right: 12px;
}

.gallery-foot {
  padding: 8px 16px 14px;
  font-size: 12px;
  color: #8f9bb3;
}
</style>
